
<div id="map-filter">
    <form
      [formGroup]="filterFormGroup"
      fxLayout="row"
      aria-describedby="portal group table"
    >
      <!-- Value form field -->
      <div
        *ngIf="filterFormGroup.errors?.['date-diff']"
        [style.color]="'red'">
        Errore l'intervallo del periodo non può essere superiore a 5 giorni
      </div>
      <div
          *ngIf="filterFormGroup.errors?.['date_err']"
          [style.color]="'red'">
          La data d'inizio non puo essere superiore alla data di fine
      </div>
      <ng-container>
            <mat-form-field fxFlex>
                <mat-label>Data Inizio</mat-label>
                <input matInput type="date" formControlName="start">
            </mat-form-field>
        </ng-container>
        <ng-container>
          <mat-form-field fxFlex>
              <mat-label>Data Fine</mat-label>
              <input matInput type="date" formControlName="end">
          </mat-form-field>
      </ng-container>
    </form> 
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
    <button mat-button mat-dialog-close>
      {{ "common.dialog.cancel" | translate }}
    </button>
    <button mat-button cdkFocusInitial color="primary" (click)="addFilter()">
      {{ "common.dialog.add" | translate }}
    </button>  
</div>
